import { createAssetApi } from '@trackly/shared';
import { createAuthenticatedBaseQuery } from '../../utils/createAuthenticatedBaseQuery';
import { getTicketsApiBaseUrl } from '../../utils/runtimeConfig';

const apiBaseUrl = getTicketsApiBaseUrl();

/**
 * Asset API shell - `getAssetById`/`getAssets`/`getAssetCosts`/`getAssetWorkOrderHistory`/
 * `listAssetDocuments` now live in @trackly/shared (createAssetApi, T057-T059); this instantiates
 * the single web-authenticated instance. Web-only endpoints (upsert, recurring tasks, document
 * view/upload/download/delete) are still injected from assetQueries.ts/assetMutations.ts,
 * mirroring the same injectEndpoints pattern those files already used.
 */
export const assetApi = createAssetApi(createAuthenticatedBaseQuery(apiBaseUrl, 'Asset API'));